import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  Container,
  Grid,
  Header,
  Icon,
  Segment
} from 'semantic-ui-react';
import {
  replace
} from 'react-router-redux';
import {
  intersection
} from 'lodash';

const roleControl = (allowedRoles) => {
  return (WrappedComponent) => {
    class RoleControl extends Component {
      constructor (props) {
        super(props);
      }

      static mapStateToProps (state) {
        return {
          authentication: state.authentication.toJS({ deep: true })
        };
      }

      static mapDispatchToProps (dispatch) {
        return {

        };
      }

      render () {
        let {
          authentication
        } = this.props;
        let roles = [];

        if (authentication.user && authentication.user.roles.length) {
          roles = authentication.user.roles.map(r => r.name);
        }

        if (intersection(allowedRoles, roles).length) {
          let props = {
            ...this.props
          };

          delete props.authentication;
          delete props.dispatch;

          return <WrappedComponent {...props} />;
        } else {
          return null;
        }
      }
    }

    return connect(
      RoleControl.mapStateToProps,
      RoleControl.mapDispatchToProps
    )(RoleControl);
  };
};

export default roleControl;



// WEBPACK FOOTER //
// ./client/components/auth/roleControl.js